export enum Role {
  Owner = 1,
  Admin = 100,
  Member = 200,
  Restricted = 300,
}

export enum RoleText {
  Owner = 'owner',
  Admin = 'admin',
  Member = 'member',
  Restricted = 'restricted',
}
